export class CollectionTransportationCost {
  public cost: string;
  public multiplier: any;
  public collection: any;
}
